import React from 'react';

import './controls.css';

// Filter-bar controls in the Sales Task List style (34px, sunken segmented track, label inside the trigger).

// Short choices (2–4) as one segmented track; the selected cell is the card surface.
export const Segmented = ({ label, options, value, onChange, className = '' }) => (
  <div className={`tp-seg ${className}`.trim()} role="group" aria-label={label}>
    {options.map((o) => (
      <button
        key={o.value}
        type="button"
        className="tp-seg-opt"
        aria-pressed={value === o.value}
        onClick={() => {
          if (value !== o.value) onChange(o.value);
        }}
      >
        {o.label}
        {o.count ? <span className="tp-seg-ct">{o.count}</span> : null}
      </button>
    ))}
  </div>
);

// A segmented track with a visible "Label:" before it, for choices whose values alone are ambiguous.
export const LabeledSegmented = ({ label, ...rest }) => (
  <span className="tp-fgrp">
    <span className="tp-fgrp-k" aria-hidden="true">
      {label}:
    </span>
    <Segmented label={label} {...rest} />
  </span>
);

// Native select drawn as a "Label: value" trigger; an orange border marks a filter that is on.
export const SelectFilter = ({
  id,
  label,
  value,
  options,
  all_label,
  onChange,
  active,
  aria_label,
  className = ''
}) => {
  const on = active === undefined ? !!value : active;
  return (
    <span className={`tp-fsel ${on ? 'is-on' : ''} ${className}`.trim()}>
      <label htmlFor={id} className="tp-fsel-k">
        {label}:
      </label>
      <select
        id={id}
        className="tp-fsel-in"
        aria-label={aria_label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {all_label !== undefined ? <option value="">{all_label}</option> : null}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <span className="tp-fsel-chev" aria-hidden="true" />
    </span>
  );
};

// A checkbox in a 34px box, level with the filters beside it.
export const CheckChip = ({ checked, onChange, inputRef, disabled, children, className = '' }) => (
  <label className={`tp-chk-chip ${className}`.trim()}>
    <input
      ref={inputRef}
      type="checkbox"
      checked={checked}
      onChange={onChange}
      disabled={disabled}
    />
    <span>{children}</span>
  </label>
);

// The filter bar: wraps its controls; the summary sentence under it says what the list shows.
export const FilterBar = ({ children, summary, label = 'Filters' }) => (
  <div className="tp-fbar-wrap">
    <div className="tp-fbar" role="group" aria-label={label}>
      {children}
    </div>
    {summary ? (
      <p className="tp-fsum" aria-live="polite">
        {summary}
      </p>
    ) : null}
  </div>
);
